export const ReportIssueIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:chat-bubble-error">
			<path
				id="Vector"
				d="M12 3C9.61306 3 7.32388 3.94821 5.63605 5.63604C3.94822 7.32387 3.00001 9.61305 3.00001 12C3.00001 14.397 3.93501 16.573 5.46301 18.186L5.96701 18.718L4.70001 21H12C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3ZM1.00001 12C1.00001 5.925 5.92501 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23H1.30001L3.52001 19.006C1.88821 17.0363 0.996743 14.5578 1.00001 12ZM13 6.5V14H11V6.5H13ZM11 15.5H13.004V17.504H11V15.5Z"
				fill="#998C9C"
			/>
		</g>
	</svg>
);
